var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Nav'),_c('div',{staticClass:"app-sidebar__overlay",attrs:{"data-toggle":"sidebar"}}),_c('Side'),_c('main',{staticClass:"app-content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }